import '@ui5/webcomponents/dist/SuggestionItem.js';
import { ListItemType, ValueState } from '../../enums';
import { withWebComponent } from '../../internal/withWebComponent';
/**
 * The `SuggestionItem` represents the suggestion item of the `Input`
 *
 * <ui5-link href="https://sap.github.io/ui5-webcomponents/playground/components/SuggestionItem" target="_blank">UI5 Web Components Playground</ui5-link>
 */
const SuggestionItem = withWebComponent('ui5-suggestion-item', ['additionalText', 'additionalTextState', 'description', 'icon', 'image', 'text', 'type'], ['iconEnd'], [], []);
SuggestionItem.displayName = 'SuggestionItem';
SuggestionItem.defaultProps = {
    additionalTextState: ValueState.None,
    type: ListItemType.Active
};
export { SuggestionItem };
